// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__qgZ2k","logo--hero":"Logo_logo--hero__BSd78"};